import { getFromLocalStorage } from "../services/helper/cl_Helper";
import { endpoints } from "../api/ApiEndPoints";

const token = getFromLocalStorage("gk");
let login_status = "";
if (token) {
  login_status = "logged_in";
} else {
  login_status = "anonymous";
}

function getGtagClientAndSession() {
  const gaCookie = document.cookie.split('; ').find(c => c.startsWith('_ga='));
  // const ga4Cookie = document.cookie.split('; ').find(c => c.startsWith('_ga_'));

  let clientId = null;
  let sessionId = null;

  if (gaCookie) {
    const parts = gaCookie.split('.');
    clientId = parts[parts.length - 1];
  }

  // if (ga4Cookie) {
  //   const parts = ga4Cookie.split('.');
  //   sessionId = parts[2]; // timestamp = session start
  // }

  // sessionId = Number(Date.now().toString());
 sessionId = Number(localStorage.getItem('sessionId'));

  return { clientId, sessionId };
}


const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    );
  const isTablet = /ipad|android(?!.*mobile)/i.test(userAgent);
  if (isTablet) return "tablet";
  if (isMobile) return "mobile";
  return "desktop";
};

const encryptUserId = async (phoneNumber) => {
  try {
    const response = await fetch(
      endpoints.encryption + `phoneNumber=${phoneNumber}`,
      {
        method: "POST",
        headers: {
          accept: "application/json",
        },
        body: "",
      }
    );
    const data = await response.json();
    if (data.code === "1000" && data.result?.encrypted) {
      return data.result.encrypted;
    } else {
      console.error("Encryption API error:", data.message);
      return phoneNumber;
    }
  } catch (error) {
    console.error("Error calling encryption API:", error);
    return phoneNumber;
  }
};

// --------> event: "registration_otp_sent"
export const trackRegistrationOTPSent = async (phoneNumber) => {
  try {
    const encryptedUserId = await encryptUserId(phoneNumber);
    const deviceType = getDeviceType();
    let { clientId, sessionId } = getGtagClientAndSession();

    const eventData = {
      event: "registration_otp_sent",
      method: deviceType,
      user_id: encryptedUserId,
      user_type: "new",
      login_status: login_status,
      client_id: clientId,
      session_id: sessionId,
    };
    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
    if (window.gtag) {
      window.gtag("event", "registration_otp_sent", eventData);
    }
    console.log("OTP Sent Tracked:", eventData);
  } catch (error) {
    console.error("Error in OTP sent tracking:", error);
  }
};

// --------> event: "sign_up"
export const trackSignUpEvent = async (phoneNumber, method = "mobile") => {
  try {
    const deviceType = getDeviceType();
    const encryptedUserId = await encryptUserId(phoneNumber);
    let { clientId, sessionId } = getGtagClientAndSession();
    const eventData = {
      event: "sign_up",
      method,
      user_id: encryptedUserId,
      user_type: "new",
      login_status: login_status,
      device_type: deviceType,
      client_id: clientId,
      session_id: sessionId,
    };
    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
    console.log("SignUp Event Tracked:", eventData);
  } catch (error) {
    console.error("Error in SignUp tracking:", error);
  }
};

// --------> event: "deposit"
export const trackDepositEvent = async (
  transactionId = "No_TXN_ID",
  phoneNumber,
  amount,
  currency,
  userType,
  isFirstDeposit
) => {
  try {
    const encryptedUserId = await encryptUserId(phoneNumber);
    const deviceType = getDeviceType();
    let { clientId, sessionId } = getGtagClientAndSession();
    const eventData = {
      event: "deposit",
      user_id: encryptedUserId,
      user_type: userType,
      login_status: login_status,
      client_id: clientId,
      session_id: sessionId,
      value: parseFloat(amount),
      currency: currency || "KES",
      is_first_deposit: isFirstDeposit,
      method: "MPESA",
      device_type: deviceType,
      transaction_id: transactionId,
    };
    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
    if (window.gtag) {
      window.gtag("event", "deposit", eventData);
    }
    console.log("Deposit Event Tracked:", eventData);
  } catch (error) {
    console.error("Error in deposit tracking:", error);
  }
};

// --------> event: "game_start"
export const trackGameStartEvent = async (
  gameName,
  gameType,
  phoneNumber,
  userType = "existing"
) => {
  try {
    const encryptedUserId = await encryptUserId(phoneNumber);
    const deviceType = getDeviceType();
    let { clientId, sessionId } = getGtagClientAndSession();
    const eventData = {
      event: "game_start",
      game_name: gameName,
      game_type: gameType,
      user_id: encryptedUserId,
      user_type: userType,
      login_status: login_status,
      device_type: deviceType,
      client_id: clientId,
      session_id: sessionId,
    };

    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
    if (window.gtag) {
      window.gtag("event", "game_start", eventData);
    }
    console.log("Game Start Event Tracked:", eventData);
  } catch (error) {
    console.error("Error in game start tracking:", error);
  }
};

// --------> event: "bonus_claim"
export const trackBonusClaimEvent = async (
  phoneNumber,
  bonus_type = "loyalty_burn",
  coinsValue,
  currency,
  userType,
  realMoneyValue
) => {
  try {
    const encryptedUserId = await encryptUserId(phoneNumber);
    const deviceType = getDeviceType();
    let { clientId, sessionId } = getGtagClientAndSession();
    const eventData = {
      event: "bonus_claim",
      bonus_type: bonus_type,
      bonus_value: coinsValue,
      currency: currency || "KES",
      user_id: encryptedUserId,
      user_type: userType || "existing",
      login_status: login_status,
      device_type: deviceType,
      real_money_value: realMoneyValue,
      client_id: clientId,
      session_id: sessionId,
    };

    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
    if (window.gtag) {
      window.gtag("event", "bonus_claim", eventData);
    }

    console.log("Bonus Claim Tracked:", eventData);
  } catch (error) {
    console.error("Error in bonus claim tracking:", error);
  }
};

// --------> event: "login_success"
export const trackLoginSuccessEvent = async (
  userId,
  userType,
  loginStatus = "success"
) => {
  try {
    const encryptedUserId = await encryptUserId(userId);
    const deviceType = getDeviceType();
    let { clientId, sessionId } = getGtagClientAndSession();
    const eventData = {
      event: "login_success",
      user_id: encryptedUserId,
      user_type: userType,
      login_status: loginStatus,
      device_type: deviceType,
      client_id: clientId,
      session_id: sessionId,
    };

    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
    if (window.gtag) {
      window.gtag("event", "login_success", eventData);
    }

    console.log("Login Success Tracked:", eventData);
  } catch (error) {
    console.error("Error in login success tracking:", error);
  }
};

// --------> event: "withdrawal"
export const trackWithdrawEvent = async (
  transactionId = "No_TXN_ID",
  phoneNumber,
  amount,
  currency,
  userType,
  method = "MPESA"
) => {
  try {
    const encryptedUserId = await encryptUserId(phoneNumber);
    const deviceType = getDeviceType();
    let { clientId, sessionId } = getGtagClientAndSession();
    const eventData = {
      event: "withdrawal",
      method,
      amount: parseFloat(amount),
      currency: currency || "KES",
      user_id: encryptedUserId,
      user_type: userType || "existing",
      login_status: login_status,
      device_type: deviceType,
      transaction_id: transactionId,
      client_id: clientId,
      session_id: sessionId,
    };
    if (window.dataLayer) {
      window.dataLayer.push(eventData);
    }
    if (window.gtag) {
      window.gtag("event", "withdrawal", eventData);
    }
    console.log("Withdrawal Event Tracked:", eventData);
  } catch (error) {
    console.error("Error in withdrawal tracking:", error);
  }
};
